import { useQuery } from 'react-query';
import { queryAllActiveNAF } from './useActiveNafList.query';
import { UseNafListOptions } from './useActiveNafList.types';
import { AllNafResponse } from '../../../types/api/endpoints/consultations/allNAF.types';

export const ALL_ACTIVE_NAF_QUERY_KEY = 'ALL_ACTIVE_NAF';

export const useActiveNafList = (options?: UseNafListOptions) => {
  return useQuery<AllNafResponse, Error>(ALL_ACTIVE_NAF_QUERY_KEY, () => queryAllActiveNAF(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
